import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import EmailForm from 'components/forms/final/EmailForm';
import EmailSnapSellForm from 'components/forms/final/EmailSnapSellForm';
import AccountForm from 'components/forms/final/AccountForm';
import AccountCreatedForm from 'components/forms/final/AccountCreatedForm';
import ConfirmationForm from 'components/forms/final/ConfirmationForm';
import PasswordForm from 'components/forms/final/PasswordForm';
import ResetPasswordForm from 'components/forms/final/ResetPasswordForm';

class FinalSubmissionPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    currentStep: PropTypes.string.isRequired,
  };

  goToPreview = () => this.props.history.push({ pathname: '/preview' });

  render() {
    const { currentStep, history, snapSell } = this.props;
    return (
      <div className="row justify-content-center mt-3">
        <div className="col-md-7">
          {currentStep === "email" && !snapSell && <EmailForm/>}
          {currentStep === "email" && snapSell && <EmailSnapSellForm/>}
          {currentStep === "account" && <AccountForm history={history} snapSell={snapSell}/>}
          {currentStep === "new_account" && <AccountCreatedForm history={history}/>}
          {currentStep === "confirm" && <ConfirmationForm snapSell={snapSell}/>}
          {currentStep === "password" && <PasswordForm history={history} snapSell={snapSell}/>}
          {currentStep === "reset" && <ResetPasswordForm/>}
          {currentStep === "email" && !snapSell && <Button onClick={this.goToPreview} color="link">Previous Step</Button>}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentStep: state.finalWizard.get('currentStep'),
});

export default connect(
  mapStateToProps,
)(FinalSubmissionPage);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/containers/SubmissionSteps/FinalSubmissionPage.jsx